module.exports = __webpack_public_path__ + "media/fall_2024_sweepstakes/twitter-x-5dc06434.svg";